import React, { useState, useEffect } from 'react';
import { Clock } from 'lucide-react';

const LiveClock = () => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const formatTime = (date, timezone) => {
    return date.toLocaleTimeString('en-US', {
      timeZone: timezone,
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    });
  };

  const formatDate = (date, timezone) => {
    return date.toLocaleDateString('en-US', {
      timeZone: timezone,
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  };

  const istTime = formatTime(time, 'Asia/Kolkata');
  const estTime = formatTime(time, 'America/New_York');
  const istDate = formatDate(time, 'Asia/Kolkata');
  const estDate = formatDate(time, 'America/New_York');

  return (
    <div className="flex items-center gap-6 bg-gradient-to-r from-slate-50 to-white px-6 py-3 rounded-xl border border-slate-200 shadow-sm">
      <div className="flex items-center gap-2">
        <Clock className="w-4 h-4 text-blue-600" strokeWidth={2} />
        <div>
          <p className="text-xs font-medium text-slate-600">IST (India)</p>
          <p className="text-sm font-bold text-slate-900">{istTime}</p>
          <p className="text-xs text-slate-500">{istDate}</p>
        </div>
      </div>
      <div className="w-px h-12 bg-slate-200" />
      <div className="flex items-center gap-2">
        <Clock className="w-4 h-4 text-emerald-600" strokeWidth={2} />
        <div>
          <p className="text-xs font-medium text-slate-600">EST (US)</p>
          <p className="text-sm font-bold text-slate-900">{estTime}</p>
          <p className="text-xs text-slate-500">{estDate}</p>
        </div>
      </div>
    </div>
  );
};

export default LiveClock;